import './register_common_react';
import { reactOnCms } from 'common/js/react_on_cms';
import CategoryCardsCarousel from 'sealink/react-components/category-cards-carousel';
import NextDepartures from 'tenants/sealink/home';
import UpcomingBooking from 'tenants/sealink/upcoming_booking';

reactOnCms.register({
  CategoryCardsCarousel,
  DepartureList: NextDepartures,
  UpcomingBooking,
});
